import React from 'react';
import { Card, CardContent } from './ui/card';
import { CreditCard, Settings, Users, Package, BarChart, Headphones } from 'lucide-react';

export const EventOperationsSection = () => {
  const tools = [
    {
      icon: CreditCard,
      title: 'Betaling',
      description: 'Hurtige, stabile betalinger ved alle salgssteder.',
      color: 'text-accent-blue',
      bg: 'bg-accent-blue/10',
      subFeatures: ['POS-betaling', 'Mobilbetaling', 'Fast Track-betaling', 'VIP bordbestilling'],
    },
    {
      icon: Settings,
      title: 'Eventdrift',
      description: 'Planlæg og afvikl events fra ét system.',
      color: 'text-accent-purple',
      bg: 'bg-accent-purple/10',
      subFeatures: ['Frivilligstyring', 'Lagerstyring', 'Opsætning af events', 'Multi-bar management'],
    },
    {
      icon: BarChart,
      title: 'Data og overblik',
      description: 'Følg salget live og få indsigt til optimering.',
      color: 'text-accent-pink',
      bg: 'bg-accent-pink/10',
      subFeatures: ['Live-dashboard', 'Salgsanalyse', 'Overblik per bar eller produkt'],
    },
    {
      icon: Headphones,
      title: 'Support',
      description: 'Hjælp før, under og efter eventet, så drift kører stabilt.',
      color: 'text-accent-blue',
      bg: 'bg-accent-blue/10',
    },
  ];

  return (
    <section data-testid="event-operations-section" className="py-24 md:py-32 bg-section-bg">
      <div className="container-custom">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-4">
            Alle værktøjer til jeres event – samlet ét sted
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {tools.map((tool, index) => {
            const Icon = tool.icon;
            return (
              <Card
                key={index}
                data-testid={`ops-tool-${index}`}
                className="group h-full border-transparent bg-white shadow-[0_18px_45px_rgba(11,31,59,0.08)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_rgba(11,31,59,0.12)]"
              >
                <CardContent className="flex h-full flex-col p-6">
                  <div className={`w-11 h-11 rounded-lg ${tool.bg} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                    <Icon className={`w-5 h-5 ${tool.color}`} />
                  </div>
                  <h3 className="text-base font-heading font-semibold text-foreground mb-1.5">
                    {tool.title}
                  </h3>
                  <p className="text-sm text-body-text leading-relaxed">
                    {tool.description}
                  </p>
                  {tool.subFeatures && (
                    <ul className="mt-3 space-y-1 text-sm text-muted-foreground">
                      {tool.subFeatures.map((item, i) => (
                        <li key={i} className="flex items-start gap-2">
                          <span className="mt-1 h-2 w-2 rounded-full bg-accent-blue flex-shrink-0" />
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
